import { Dimensions } from "react-native";
import { atom } from "recoil";

const { width: startingWidth } = Dimensions.get("window");

export const MOBILE_WIDTH_THRESHOLD = 500 + 192;

export const mobileModeState = atom<boolean>({
  key: "ScreenLayoutMobleMode",
  default: startingWidth < MOBILE_WIDTH_THRESHOLD,
});
